import { Icon, Typography } from "best-common-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getVideo } from "../../httpClients/ClipsApi";
import { BoxFileDTO } from "../../types/Video";
import { formatMetadataCalendarDate } from "../../utils/DateUtils";
import { formatName } from "../../utils/PersonUtils";
import InlineLoading from "../loading/InlineLoading";
import VideoThumbnail from "./VideoThumbnail";

type RelatedVideoProps = {
  fileId: number | string;
};

const RelatedVideo: React.FC<RelatedVideoProps> = ({ fileId }) => {
  const [video, setVideo] = useState<BoxFileDTO | undefined>(undefined);

  const fetchData = async () => {
    const result: BoxFileDTO = await getVideo(fileId);
    setVideo(result);
  };

  useEffect(() => {
    void fetchData();
  }, []);

  return (
    <div className="bcr-mt-2">
      {video ? (
        <Link to={`/video/${fileId}`}>
          <div>
            <div className="d-flex">
              <div>
                <VideoThumbnail src={video.boxSharedLink.downloadURL} />
              </div>
              <div className="d-flex flex-column">
                <Typography color="textSecondary">
                  <Icon iconName="fa-file-video" className="bcr-me-2" />
                  {video.fileName}
                </Typography>
                <Typography color="textSecondary">
                  <Icon iconName="fa-user" className="bcr-me-2" />
                  {formatName(video.metadata.firstName, video.metadata.lastName)}
                </Typography>
                <Typography color="textSecondary">
                  <Icon iconName="fa-clock" className="bcr-me-2" />
                  {formatMetadataCalendarDate(video.metadata.filmDate)}
                </Typography>
                <Typography color="textSecondary">
                  <Icon iconName="fa-school" className="bcr-me-2" />
                  {video.metadata.school}
                </Typography>
                <Typography color="textSecondary">
                  <Icon iconName="fa-location-dot" className="bcr-me-2" />
                  {video.metadata.city
                    ? video.metadata.city + ", "
                    : "" + video.metadata.state
                    ? video.metadata.state
                    : ""}
                </Typography>
                <Typography color="textSecondary">
                  <Icon iconName="fa-video" className="bcr-me-2" />
                  {video.metadata.source}
                </Typography>
              </div>
            </div>
          </div>
        </Link>
      ) : (
        <div className="d-flex justify-content-center">
          <InlineLoading />
        </div>
      )}
    </div>
  );
};

export default RelatedVideo;
